//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"Associative",1,1]],[[["numPhysics","physics"],"GetTentativePhysics",{},0,0],[["physics","enable"],"EnableObjectsConversion",{},2,0],[[],"GetAssociativeState",{R_:{options:''}},0,0],[["options"],"SetAssociativeState",{},1,0],[["recreate"],"SetRecreateObjectState",{},1,0]],[]];
SPLM.Mechatronics.AnimationConversionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.AnimationConversionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.AnimationConversionBuilder.Options = class{
    constructor(associative,associativeName,associativeVisibility,associativeColor){
        this.associative=associative;this.associativeName=associativeName;this.associativeVisibility=associativeVisibility;this.associativeColor=associativeColor;}
    get Associative(){return this.associative}
    set Associative(val){this.associative = val}
    get Associativename(){return this.associativeName}
    set Associativename(val){this.associativeName = val}
    get Associativevisibility(){return this.associativeVisibility}
    set Associativevisibility(val){this.associativeVisibility = val}
    get Associativecolor(){return this.associativeColor}
    set Associativecolor(val){this.associativeColor = val}
};

export default SPLM;